import cookie from "js-cookie";

// BE JWT süresiyle (Backend V3/controllers/auth.js: jwt.sign(..., { expiresIn: "1h" }))
// EŞLEŞMELİ. Cookie bundan uzun yaşarsa isAuth() token süresi dolduktan sonra da
// true döner: kullanıcı "giriş yapmış" görünür ama ilk yazma isteğinde BE 401 döner
// ve signout() sessizce anasayfaya atar (bkz .agent/GOTCHAS.md).
const TOKEN_COOKIE_EXPIRES_DAYS = 1 / 24; // ~1 saat

// Set in Cookie
export const setCookie = (key, value, expiresInDays = TOKEN_COOKIE_EXPIRES_DAYS) => {
  if (window !== "undefiend") {
    cookie.set(key, value, {
      expires: expiresInDays,
    });
  }
};
// remove from cookie
export const removeCookie = (key) => {
  if (window !== "undefined") {
    cookie.remove(key, {
      expires: 1,
    });
  }
};

// Get from cookie such as stored token
// Will be useful when we need to make request to server with token
export const getCookie = (key) => {
  if (window !== "undefined") {
    return cookie.get(key);
  }
};

// Set in localstorage
export const setLocalStorage = (key, value) => {
  if (window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

// Remove from localstorage
export const removeLocalStorage = (key) => {
  if (window !== "undefined") {
    localStorage.removeItem(key);
  }
};

// Auth enticate user by passing data to cookie and localstorage during signin
export const authenticate = (response, next) => {
  //  console.log('AUTHENTICATE HELPER ON SIGNIN RESPONSE', response);
  //  console.log("DefaultPage:", response.data.defaultPage);
  setCookie("token", response.data.token);
  // setLocalStorage("user", {
  //   ofis_adi: response.data.ofis_adi,
  //   adi: response.data.adi,
  //   soyadi: response.data.soyadi,
  //   rol: response.data.rol,
  //   para_birimi: response.data.para_birimi,
  //   roller: response.data.roller,
  //   rol_ad: response.data.rol_ad,
  //   change_logs:response.data.change_logs,
  // });
  setLocalStorage("user", response.data);

  next(response.data.defaultPage);
};

// Access user info from localstorage
export const isAuth = () => {
  if (window !== "undefined") {
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      if (localStorage.getItem("user")) {
        // console.log("user");
        return JSON.parse(localStorage.getItem("user"));
      } else {
        return false;
      }
    }
    return false;
  }
};

// --- Dönüş yolu -------------------------------------------------------------
// Oturum bittiğinde kullanıcının bulunduğu URL saklanır; tekrar giriş yapınca
// rolünün defaultPage'ine değil kaldığı ekrana döner. Üç bitiş yolunu da kapsar:
//   1) BE 401 (token yok/süresi dolmuş) -> Istek.js handleApiError -> signout()
//      NOT: 403 (yetki yok) ARTIK ÇIKIŞ YAPTIRMAZ, oturum korunur.
//   2) manuel çıkış -> Navbar2 -> signout()
//   3) cookie'nin kendi 1 saatlik ömrü dolar, 401 hiç gelmez -> isAuth() false
//      olur ve PrivateRoute kullanıcıyı /'a atar (bu yolda signout() ÇALIŞMAZ,
//      bu yüzden PrivateRoute kaydı ayrıca yapar).
//   4) web push bildirimindeki linke oturum kapalıyken tıklanır: service worker
//      (public/service-worker.js) payload'daki url'e gider, PrivateRoute girişe
//      atar. Bu kayıt SAHİPSİZ olur — tarayıcıda oturum yoktur, kimin için
//      geldiği bilinemez — ve giriş yapan kullanıcıya verilir.
//
// localStorage: "giriş yapılana kadar silinmesin" — sekme/tarayıcı kapansa bile
// durur, yalnızca giriş onu tüketince silinir (tek kullanımlık).
const DONUS_YOLU_KEY = "donus_yolu";
// En son geri dönülen yol + zamanı. Döngü kesici: dönülen sayfa kullanıcıya kapalıysa
// hemen yeniden oturum bitişi yaşanır ve aynı yol tekrar kaydedilirse kullanıcı sisteme
// HİÇ giremez. Dönüşten hemen sonra gelen bitiş bu yüzden aynı yolu tekrar kaydetmez ve
// kullanıcı defaultPage'ine düşer.
//
// NOT: 401/403 ayrımından SONRA bu senaryonun ana tetikleyicisi ortadan kalktı —
// kapalı sayfanın 403'ü artık çıkış yaptırmıyor. Engel yine duruyor: süresi dolmuş
// token ile kapalı bir sayfaya dönme durumu hâlâ mümkün ve maliyeti sıfır.
//
// Engel neden SÜRELİ: kalıcı olsaydı, gün içinde aynı ekranda ikinci kez süresi dolan
// kullanıcı bir daha o ekrana dönemezdi. Kapalı sayfanın hatası saniyeler içinde gelir;
// normal oturum bitişi ise en az bir saat sonra olur — 60 sn ikisini rahatça ayırır.
const DONUS_SON_DENENEN_KEY = "donus_son_denenen";
const DONUS_DONGU_PENCERESI_MS = 60 * 1000;

// Yalnızca pencere içindeyse yolu döndürür; dışındaysa engel kalkmış sayılır.
const engellenenYol = () => {
  try {
    const ham = localStorage.getItem(DONUS_SON_DENENEN_KEY);
    const kayit = ham ? JSON.parse(ham) : null;
    if (!kayit) return null;
    return Date.now() - kayit.zaman < DONUS_DONGU_PENCERESI_MS ? kayit.yol : null;
  } catch {
    return null;
  }
};

// Yalnızca aynı origin içinde kalan yollar. "//baska-site.com" tarayıcıda
// protokol-göreli MUTLAK adrestir, "javascript:" script çalıştırır — ikisi de
// reddedilir. "/" giriş sayfasının kendisi, kaydetmek anlamsız.
const gecerliDonusYolu = (yol) =>
  typeof yol === "string" &&
  yol.startsWith("/") &&
  !yol.startsWith("//") &&
  yol !== "/" &&
  // TEST 2.1 (06.10.2026): bozuk yollar (/projeId/undefined) kullanıcıyı her
  // girişte hatalı sayfaya hapsediyordu.
  !/\/(undefined|null)(\/|$|\?)/.test(yol);

// Cookie silinmiş ama localStorage'daki kullanıcı hâlâ duruyor olabilir (yukarıdaki
// 3. yol). Bu yüzden sahibi isAuth() ile değil doğrudan localStorage'dan okuyoruz:
// isAuth() cookie'ye bağlı olduğu için o anda false döner.
const oturumSahibiId = () => {
  try {
    const ham = localStorage.getItem("user");
    return ham ? JSON.parse(ham)?._id ?? null : null;
  } catch {
    return null; // bozuk JSON: sahipsiz say, yol kaydedilmez
  }
};

// signout() içindeki 800 ms'lik yönlendirme gecikmesinde PrivateRoute yeniden
// render olabilir; o an localStorage'daki kullanıcı silinmiş olduğu için kayıt
// SAHİPSİZE düşer ve manuel çıkış devrinde yeni kullanıcı öncekinin ekranına gider.
// Bu mandal o pencereyi kapatır. Sıfırlanmasına gerek yok: sayfa /'a gidince modül
// baştan yüklenir.
let cikisYapiliyor = false;

export const donusYoluKaydet = (yol) => {
  const hedef = yol || window.location.pathname + window.location.search;
  if (!gecerliDonusYolu(hedef) || cikisYapiliyor) return;
  // Bu yola az önce dönülmüş ve yine buraya düşülmüşse yol kullanıcıya kapalıdır;
  // kaydetmeyi reddederek döngüyü kır. Başka bir ekrandan çıkışta engel yok.
  if (hedef === engellenenYol()) return;
  // sahip null olabilir: oturum kapalıyken tıklanan bildirim linki (4. yol).
  setLocalStorage(DONUS_YOLU_KEY, { yol: hedef, sahip: oturumSahibiId() });
};

// Okunduğu anda silinir (tek kullanımlık) — sahibi tutmasa bile, yoksa yol orada
// kalıp sonraki girişleri de kaçırır. Yol yalnızca AYNI kullanıcı geri dönerse
// verilir: manuel çıkış tam olarak makineyi başkasına devretme biçimidir, aksi
// halde yeni kullanıcı öncekinin ekranına düşer.
export const donusYoluAlVeTemizle = (kullaniciId) => {
  let kayit = null;
  try {
    const ham = localStorage.getItem(DONUS_YOLU_KEY);
    kayit = ham ? JSON.parse(ham) : null;
  } catch {
    kayit = null;
  }
  removeLocalStorage(DONUS_YOLU_KEY);
  if (!kayit) return null;
  // Sahipsiz kayıt (bildirim linki) giriş yapan kullanıcıya verilir; sahipli kayıt
  // yalnızca sahibine.
  if (kayit.sahip != null && kayit.sahip !== kullaniciId) return null;
  if (!gecerliDonusYolu(kayit.yol)) return null;
  setLocalStorage(DONUS_SON_DENENEN_KEY, { yol: kayit.yol, zaman: Date.now() });
  return kayit.yol;
};

export const signout = () => {
  // TEK SEFERLİK: aynı anda birden çok istek 401 dönebilir (bir ekran açılışta 3-4
  // istek atıyor). Her biri signout() çağırırsa hem üst üste toast/yönlendirme olur
  // hem de aşağıdaki 800 ms'lik pencere içinde yönlendirme tekrar tekrar planlanır.
  if (cikisYapiliyor) return;
  // Silmelerden ÖNCE: kayıt localStorage'daki kullanıcıdan sahibi okuyor.
  donusYoluKaydet();
  cikisYapiliyor = true;
  // 2026-10-08: Cikis yapildiginda backend'e logout istegi atarak token'i karalisteye al
  try {
    const mevcutToken = getCookie("token");
    if (mevcutToken && typeof fetch === "function") {
      fetch("/api/logout", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${mevcutToken}`,
        },
      }).catch(() => {});
    }
  } catch (e) {}
  removeCookie("token");
  removeLocalStorage("user");
  // GİRİŞ SAYFASINDA YÖNLENDİRME YOK. Aksi halde: giriş ekranındaki bir istek 401
  // döner -> signout() -> "/" adresine git -> sayfa baştan yüklenir -> istek yine
  // 401 döner -> ... kullanıcı sürekli yenilenen bir giriş ekranında kalır.
  // Oturum verisi yine temizlendi; yapılacak başka bir şey yok.
  if (window.location.pathname === "/") return;
  // Yönlendirmeden önce kısa bir gecikme: "oturum süreniz doldu" toast'ı
  // görünmeden sayfa anında değişmesin (bkz .agent/GOTCHAS.md).
  setTimeout(() => {
    window.location.assign("/");
  }, 800);
  //next(); //! yönlendirme için gerekli
};

/*
export const updateUser = (response, next) => {
    console.log('UPDATE USER IN LOCALSTORAGE HELPERS', response);
    if (typeof window !== 'undefined') {
        let auth = JSON.parse(localStorage.getItem('user'));
        auth = response.data;
        localStorage.setItem('user', JSON.stringify(auth));
    }
    next();
};*/
